itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    const initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                ScrollTrigger.clearScrollMemory(); // eslint-disable-line
                if (element.classList.contains("js-trigger-nav")) {
                    const extraMenu = element.querySelector(".js-extra-menu");

                    const setActive = function (link) {
                        const paddingLeft = getComputedStyle(extraMenu).paddingLeft || 0;
                        links.forEach(el => el.parentNode.classList.remove("js-active"));
                        link.parentNode.classList.add("js-active");
                        const scroll = link.parentNode.offsetLeft - parseInt(paddingLeft, 10);
                        menu.scrollLeft = scroll;
                    };

                    const menu = element.querySelector(".js-trigger-menu");
                    let links = gsap.utils.toArray(".js-trigger-nav-link"); // eslint-disable-line

                    links.forEach(a => {
                        let element = document.querySelector(a.getAttribute("href"));

                        ScrollTrigger.create({ // eslint-disable-line
                            trigger: element,
                            start: "top 25%",
                            end: "bottom 25%",
                            onToggle: self => self.isActive && setActive(a)
                        });
                    });
                }

                if (element.classList.contains("js-accordion-trigger")) {
                    const animTarget = element.querySelector(".js-anim-target");
                    const animElWrappers = element.querySelectorAll(".js-anim-el-wrapper");
                    const animEls = animElWrappers.length > 0 && animElWrappers[0].querySelectorAll(".js-anim-el");
                    const targetsAnimEls = gsap.utils.toArray(animEls); 
                    const allAnimElTimelines = [];

                    animTarget.classList.add("js-active");

                    targetsAnimEls.forEach(function (targetAnimEl) {
                        gsap.set(targetAnimEl, {
                            xPercent: targetAnimEl.getAttribute("data-transform-x") || -100,
                            yPercent: targetAnimEl.getAttribute("data-transform-y") || -100
                        });
                    });

                    if (animEls.length > 0) {
                        gsap.to(targetsAnimEls, {
                            delay: 1.5,
                            duration: 0.5,
                            stagger: 0.3,
                            xPercent: -50,
                            yPercent: -50,
                            opacity: 0,
                            onStart: function () {
                            }
                        })
                    }

                    Array.prototype.forEach.call(animElWrappers, function (animElWrapper, animElWrapperIndex) {
                        const animEls = animElWrapper.querySelectorAll(".js-anim-el");
                        const tl = gsap.timeline({id: "anim" + animElWrapperIndex});

                        Array.prototype.forEach.call(animEls, function (animEl) {
                            tl.set(animEl, {
                                xPercent: animEl.getAttribute("data-transform-x") || -100,
                                yPercent: animEl.getAttribute("data-transform-y") || -100,
                                opacity: 1
                            });
                        });

                        tl.to(animEls, {
                            delay: 0.5,
                            duration: 0.5,
                            stagger: 0.3,
                            xPercent: -50,
                            yPercent: -50,
                            opacity: 0
                        })

                        tl.pause(0);

                        allAnimElTimelines.push(tl);
                    });

                    const accordionContentEls = document.querySelectorAll(".composition__accordion-content");
                    const accordionIndexTargetEls = document.querySelectorAll("[data-accordion-index-target]");

                    Array.prototype.forEach.call(accordionContentEls, function (el) {
                        el.style.height = "auto";
                        el.style.display = "block";
                        let height = el.clientHeight + "px";
                        el.setAttribute("data-height", height);
                        el.style.height = "0px";
                        el.style.opacity = 0;
                        el.style.display = "";
                    });

                    const completeActivePicture = function () {
                        const self = this;
                        const target = self.targets()[0];
                        accordionIndexTargetEls[target.getAttribute("data-index")].classList.remove("js-active");
                        accordionIndexTargetEls[parseInt(target.getAttribute("data-index"), 10) + 1].classList.add("js-active");
                        allAnimElTimelines[parseInt(target.getAttribute("data-index"), 10) + 1].play(0);
                    }

                    const completeReverseActivePicture = function () {
                        const self = this;
                        const target = self.targets()[0];
                        accordionIndexTargetEls[target.getAttribute("data-index")].classList.remove("js-active");
                        accordionIndexTargetEls[parseInt(target.getAttribute("data-index"), 10) - 1].classList.add("js-active");
                        allAnimElTimelines[parseInt(target.getAttribute("data-index"), 10) - 1].play(0);
                    }

                    const targets = gsap.utils.toArray(accordionContentEls);

                    const middleTargets = targets;
                    const firstTarget = middleTargets.shift();
                    const lastTarget = middleTargets.pop();

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            pin: true,
                            start: 'top top',
                            end: 'bottom top',
                            scrub: 1,
                            ease: 'linear',
                            pinSpacing: "margin"
                        }
                    })

                    gsap.set(firstTarget, {
                        height: firstTarget.getAttribute("data-height"),
                        opacity: 1
                    });

                    const tl1 = gsap.timeline();

                    tl1
                    .to(firstTarget, {
                        height: 0,
                        opacity: 0,
                        duration: 0.5,
                        onComplete: completeActivePicture,
                    });
                
                    const tl2 = gsap.timeline();

                    tl2.to(targets, {
                        height: function (index, target) {
                            return target.getAttribute("data-height");
                        },
                        opacity: 1,
                        // duration: 0.5,
                        stagger: {
                            yoyo: true,
                            repeat: 1,
                            each: 1,
                            onComplete: completeActivePicture,
                            onReverseComplete: completeReverseActivePicture
                        }
                    })

                    const tl3 = gsap.timeline();

                    tl3.to(lastTarget, {
                        height: lastTarget.getAttribute("data-height"),
                        opacity: 1,
                        duration: 0.5,
                        onReverseComplete: completeReverseActivePicture
                    })

                    tl.add(tl1).add(tl2).add(tl3);
                }
            }
        };

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    };

    module.callback = initScrollActions;
});